import React, { RefAttributes } from 'react';
import styled from '@emotion/styled';
import { keyframes } from '@emotion/core';
import { themeGet } from 'styled-system';
import {
  Box,
  LoadingIndicator,
  LoadingIndicatorProps,
} from 'roo-ui/components';

const pulse = keyframes`
 0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.6;
  }
`;

const Shimmer = styled(Box)`
  background-color: ${themeGet('colors.greys.alto')};
  animation: ${pulse} 2s ease-in-out infinite;
`;

const IndicatorWithRef = (
  props: RefAttributes<any> & LoadingIndicatorProps
) => <LoadingIndicator {...props} />;

interface ImageLoadingIndicatorProps {
  width?: string | number | string[] | number[];
  height?: string | number | string[] | number[];
  cover?: boolean;
}

export const ImageLoadingIndicator = React.forwardRef(
  (
    { width, height, cover = true }: ImageLoadingIndicatorProps,
    ref: React.Ref<HTMLDivElement>
  ) => {
    if ((!width && !height) || !cover)
      return <IndicatorWithRef ref={ref} size={12} color="greys.steel" />;

    const dimensions = {
      width: width ?? '100%',
      height: height ?? '100%',
    };
    return <Shimmer {...dimensions} data-testid="shimmer" />;
  }
);
